import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const AutoregressionScatterplotChart = (props) => {
    let autoregData = props.getAnalysisRes.autoregression;
    let xDisplayName = autoregData.x_display_name;
    let yDisplayName = autoregData.y_display_name;
    let scatter = autoregData.scatter;
    let scatterLine = autoregData.scatter_line;

    let regScatterplotOptions = {
        chart: {
            marginRight: 30,
            marginLeft: 77,
            marginTop: 20,
            zoomType: 'xy',
            height: 400
        },
        credits: {
            enabled: false
        },
        title: {
            text: undefined,
            style: { fontSize: '11px' }
        },
        subtitle: {
            text: undefined,
            style: { fontSize: '10px' }
        },
        xAxis: [
            {
                endOnTick: true,
                tickLength: 0,
                lineWidth: 0,
                labels: {
                    enabled: true,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '11px'
                    }
                },
                title: {
                    text: xDisplayName,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        yAxis: [
            {
                labels: {
                    style: { fontSize: '11px' }
                },
                title: {
                    text: yDisplayName,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        navigation: {
            buttonOptions: {
                align: 'right',
                backgroundColor: '#ffffff',
                borderColor: '#B0B0B0',
                borderRadius: 3,
                borderWidth: 1,
                enabled: true,
                height: 20,
                hoverBorderColor: '#909090',
                hoverSymbolFill: '#81A7CF',
                hoverSymbolStroke: '#4572A5',
                symbolFill: '#E0E0E0',
                symbolSize: 12,
                symbolStroke: '#A0A0A0',
                symbolStrokeWidth: 1,
                symbolX: 11.5,
                symbolY: 10.5,
                verticalAlign: 'top',
                width: 24,
                y: 10
            },
            menuStyle: {
                border: '1px solid #A0A0A0',
                background: '#FFFFFF'
            },
            menuItemStyle: {
                padding: '0 5px',
                background: 'NONE',
                color: '#303030'
            },
            menuItemHoverStyle: {
                background: '#4572A5',
                color: '#FFFFFF'
            }
        },
        tooltip: {
            useHTML: true,
            shape: 'square',
            shared: false,
            borderRadius: 0,
            borderWidth: 0,
            shadow: false,
            enabled: true,
            backgroundColor: 'none',
            formatter: function () {
                if (this.point.company_id) {
                    var string = `<div class="tooltipContainer">Company ID: ${this.point.company_id}<br>FY: ${this.point.fy}<br>${this.x}:${this.y}</div>`;
                } else {
                    var string = `<div class="tooltipContainer">${this.x.toFixed(
                        4
                    )}:${this.y.toFixed(4)}</div>`;
                }
                return string;
            }
        },
        plotOptions: {
            scatter: { marker: { radius: 2 } }
        },

        legend: {
            enabled: false,
            layout: 'vertical',
            align: 'left',
            x: 10,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor: '#FFFFFF'
        },
        series: [
            {
                name: 'seriesOneName1',
                color: '#407CB1',
                type: 'scatter',
                yAxis: 0,
                // data: scatterDataIndex,
                data: scatter,
                turboThreshold: 50000
            },

            {
                name: 'seriesTwoName1',
                type: 'spline',
                color: '#60091D',
                yAxis: 0,
                // data: scatter_data['chart']['fitted'],
                data: scatterLine,
                marker: { enabled: false },
                turboThreshold: 50000
            }
        ]
    };

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={regScatterplotOptions}
            ref={props.forwardedRef}
        />
    );
};

export default AutoregressionScatterplotChart;
